//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from './mg-form/mixins/emitter';

export default {
  name: 'mgText',
  mixins: [Emitter],
  props: {
    type: { type: String, default: 'text' },
    value: { type: String, default: '' },
    placeholder: {
      type: String,
    },
    maxLength: {
      type: Number,
      default: 300,
    },
  },
  computed: {
    length() {
      return this.value.length;
    },
  },
  watch: {
    value(value) {
      this.currentValue = value;
    },
  },
  data() {
    return { currentValue: this.value, id: this.label };
  },
  mounted() {
    if (this.$parent.labelFor) this.$refs.input.id = this.$parent.labelFor;
  },
  methods: {
    handleInput(e) {
      const value = e.target.value;
      this.currentValue = value;
      this.$emit('input', value);
      this.dispatch('mgFormItem', 'form-change', value);
    },
    handleBlur() {
      this.dispatch('mgFormItem', 'form-blur', this.currentValue);
    },
  },
};
